import React, { useCallback, useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import TabBar from '../../../../../../component/tab-bar/tab-bar';
import { PermissionGroupDetails } from '../../../../../../api/types/settings/permissions/permission-group-details.type';
import { getPermissionGroupDetailsOperation } from './operations/get-permission-group-details-operation';
import { PermissionGroupUsersTab } from './tabs/users-tab/permission-group-users-tab';
import { PermissionGroupPermissionsTab } from './tabs/permissions-tab/permission-group-permissions-tab';

const tabs = ['משתמשים', 'הרשאות'];

interface PermissionGroupPageDialogProps {
  visible: boolean;
  groupId: number | null;
  onHide: () => void;
}

export const PermissionGroupPageDialog: React.FC<
  PermissionGroupPageDialogProps
> = ({ visible, groupId, onHide }) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [groupDetails, setGroupDetails] =
    useState<PermissionGroupDetails | null>(null);

  const fetchGroupDetails = useCallback(
    async (silent = false) => {
      if (groupId == null) {
        return;
      }

      await getPermissionGroupDetailsOperation(
        groupId,
        setGroupDetails,
        silent
          ? () => {
              //
            }
          : setLoading,
      );
    },
    [groupId],
  );

  useEffect(() => {
    if (!visible || groupId == null) {
      setGroupDetails(null);
      setSelectedTabIndex(0);
      return;
    }

    void fetchGroupDetails();
  }, [visible, groupId, fetchGroupDetails]);

  const dialogHeader = groupDetails?.name
    ? `קבוצת הרשאות - ${groupDetails.name}`
    : 'קבוצת הרשאות';

  return (
    <Dialog
      header={dialogHeader}
      visible={visible}
      onHide={onHide}
      style={{ width: '960px', maxWidth: '95vw' }}
      dismissableMask
      draggable={false}
      resizable={false}
    >
      <div style={{ direction: 'rtl', minHeight: '320px' }}>
        {loading ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '280px',
            }}
          >
            <ProgressSpinner />
          </div>
        ) : (
          <>
            {groupDetails?.description?.trim() && (
              <div
                style={{
                  fontSize: '14px',
                  color: '#4b5563',
                  marginBottom: '8px',
                }}
              >
                {groupDetails.description}
              </div>
            )}

            <TabBar
              tabs={tabs}
              activeIndex={selectedTabIndex}
              onClick={setSelectedTabIndex}
            />

            {selectedTabIndex === 0 && groupId != null && (
              <PermissionGroupUsersTab
                groupId={groupId}
                users={groupDetails?.users ?? []}
                onUsersChanged={() => fetchGroupDetails(true)}
              />
            )}
            {selectedTabIndex === 1 && groupId != null && (
              <PermissionGroupPermissionsTab
                groupId={groupId}
                permissions={groupDetails?.permission ?? []}
                onPermissionsChanged={() => fetchGroupDetails(true)}
              />
            )}
          </>
        )}
      </div>
    </Dialog>
  );
};
